import React from 'react';
import browserDetect from 'browser-detect';

import VideoPlayer from './Player';

import Loading from '../Loading';

class PlayerComponent extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			eventId: '_',
			videoJsOptions: {},
			context: '',
			contextUrl: '',
		};

		this.onLoad = () => {};
	}
	componentDidMount() {
		this.startPlayer();
	}
	startPlayer = () => {
		const {
			eventId = '_',
			context = 'EventoVirtual.co - Streaming for Everyone',
			contextUrl = 'https://eventovirtual.co?utm_source=playerEV&utm_medium=ClickRight&utm_campaign=ReproductorEV',
			url = '',
			type = 'm3u8',
			params = '',
			onLoad = () => {},
		} = this.props;

		this.onLoad = onLoad;

		const data = {};
		const arrParams = params.split('&');
		arrParams.forEach((paramsRow) => {
			const _arr = paramsRow.split('=');
			if (_arr[1]) {
				data[_arr[0]] = _arr[1];
			}
		});

		let poster = '//streaming.com.co/images/estatica.jpg',
			autoplay = false; /*,
		/*title = 'EventoVirtual',
		destination = 'https://eventovirtual.co/',
		image = 'https://app.eventovirtual.co/isologo-eventovirtual-30x30.png';*/

		if (data['poster']) {
			poster = `https://static.eventovirtual.co/v1/AUTH_93e97be4d41e467687f422fd1a8ce372/eventovirtual-public/events/${eventId}/IMAGE/PLAYER_BACKGROUND${data['poster']}`;
		}
		if (data['image']) {
			//image = `https://static.eventovirtual.co/v1/AUTH_93e97be4d41e467687f422fd1a8ce372/eventovirtual-public/events/${eventId}/IMAGE/PLAYER_ICON${data['image']}`;
		}

		autoplay = data['autoplay'] === 'true';

		let srcType =
			type === 'youtube' ? 'video/youtube' : 'application/x-mpegURL';
		const browserDetected = browserDetect();

		try {
			if (!browserDetected.mobile) {
				if (browserDetected.name.indexOf('afari') !== -1) {
					//srcType = 'video/mp4';
				}
			}
		} catch (error) {}

		const videoJsOptions = {
			controls: true,
			preload: 'none',
			width: '100%',
			height: 350,
			autoplay,
			poster,
			/*sources: [
			{
				src:
					'https://cdn3.wowza.com/1/YW5jaENNVERwQzBS/Wi9IMlV0/hls/live/playlist.m3u8',
				type: 'application/x-mpegURL',
			},
        ],
		sources: [
			{
				src: 'https://www.youtube.com/watch?v=L45yueQwmUc',
				type: 'video/youtube',
			},
        ],*/
			sources: [
				{
					src: url,
					type: srcType,
				},
			],
			techOrder: [type],
			youtube: {
				iv_load_policy: 1,
				ytControls: 1,
				controls: 0,
				rel: 0,
				showinfo: 0,
			},
			html5: {
				hls: {
					overrideNative: true,
				},
			},
		};

		const self = this;
		const onSuccess = () => {
			self.setState({
				eventId,
				videoJsOptions,
				context,
				contextUrl,
			});
		};

		onSuccess();
		/*if (type === 'youtube') {
			onSuccess();
		} else {
			Server.events
				.getSource(eventId)
				.then((response) => {
					videoJsOptions.sources[0].src = response.data.url;
					onSuccess();
				})
				.catch(() => {
					setTimeout(() => {
						Server.events.getSource(eventId).then((response) => {
							console.log(response.data);
							videoJsOptions.sources[0].src = response.data.url;
							onSuccess();
						});
					}, 2000);
				});
		}*/
	};
	render() {
		if (this.state.eventId === '_') {
			return <Loading isVisible isFullScren={false} />;
		}

		const { eventId, videoJsOptions, context, contextUrl } = this.state;
		return (
			<VideoPlayer
				eventId={eventId}
				videoJsProps={videoJsOptions}
				context={context}
				contextUrl={contextUrl}
				onLoad={this.onLoad}
			/>
		);
	}
}

export default PlayerComponent;
